import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { allowUserSendMessages } from '@juvare/contact-management/backend/features/permissions/shared';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation, useUserState } from '../../../../../hooks';
import { useInboxClient } from '../../../hooks';
export const InboxArchivedNotificationActions = ({ notification, onReload, onCloseDialog, }) => {
    const { t } = useAlertUiTranslation();
    const userState = useUserState();
    const inboxClient = useInboxClient();
    const allowSendMessages = allowUserSendMessages(userState);
    return (React.createElement(Box, { sx: { alignSelf: 'self-start', display: 'flex', gap: 1, color: themeColors.primary.base } }, allowSendMessages && (React.createElement(Tooltip, { title: t('common.restore') },
        React.createElement(IconButton, { color: 'primary', onClick: () => {
                showConfirmDialog({
                    title: t('restoreArchivedAlertsDialog.title', { count: 1, page: 'Inbox' }),
                    confirmLabel: t('common.restore'),
                    onConfirm: () => {
                        inboxClient
                            .unArchive([notification.id])
                            .then(() => {
                            onReload(true);
                            onCloseDialog === null || onCloseDialog === void 0 ? void 0 : onCloseDialog();
                            showAlertSnackbar({
                                message: t('inboxTable.dialog.notificationRestored'),
                                autoHideDuration: 1000,
                                type: 'success',
                            });
                        })
                            .catch(handleErrorSnackbar);
                    },
                });
            } },
            React.createElement(UnarchiveOutlinedIcon, null))))));
};
